
import XHeader from 'vux/src/components/x-header/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'


export default {
components: {
XHeader,
Tab,
TabItem,
Swiper,
SwiperItem,
Group,
XInput,
XButton,
Icon,
Cell,
LoadMore
},
data() {
return {
tabIndex: 0,
findchar: "",
subjectList: [],
outLineList: [],
isSubjectLoadMore: false,
isOutLineLoadMore: false,
isShowSubjectLoadMore: false,
isShowOutLineLoadMore: false
};
},
created() {},
methods: {
initData() {
this.tabIndex = 0;
this.findchar = "";
this.subjectList = [];
this.outLineList = [];
this.isShowSubjectLoadMore = false;
this.isShowOutLineLoadMore = false;
},
onSearchClick() {
if (this.tabIndex == 0) {
this.searchSubjectList(false);
} else if (this.tabIndex == 1) {
this.searchOutLineList();
}
},
searchSubjectList(isMore) {
if (!isMore) {
if (this.findchar == undefined || this.findchar.length == 0) {
this.$vux.toast.text("请输入搜索关键字", "bottom");
return;
}

this.$vux.loading.show({
text: "请稍候..."
});

this.isShowSubjectLoadMore = true;
}

var minsubjectid = 0;
if (
isMore &&
this.subjectList != undefined &&
this.subjectList.length > 0
) {
minsubjectid = this.subjectList[this.subjectList.length - 1].isubjectid;
}

this.$http({
method: "post",
url: "wxexam.ashx?op=SearchSubjectList",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
courseId: this.$store.getters.getClassInfo.CourseId,
findchar: this.findchar,
minsubjectid: minsubjectid,
pagesize: 20
}
})
.then(response => {
if (response.status == 200 && response.data.errcode == 0) {
if (this.subjectList != undefined && isMore) {
response.data.data.forEach(subject => {
subject.ctitle = subject.ctitle.replace(/<img(.*?)>/ig, "【图】");
this.subjectList.push(subject);
});
this.isSubjectLoadMore = false;
} else {
this.subjectList = [];
response.data.data.forEach(subject => {
subject.ctitle = subject.ctitle.replace(/<img(.*?)>/ig, "【图】");
this.subjectList.push(subject);
});
this.$vux.loading.hide();
}

if (
response.data.data != undefined &&
response.data.data.length < 20
) {
this.isShowSubjectLoadMore = false;
}
} else {
this.isSubjectLoadMore = false;
this.$vux.loading.hide();
}
})
.catch(function(error) {
console.log("error:" + error);
this.$vux.loading.hide();
this.isSubjectLoadMore = false;
});
},
searchOutLineList(isMore) {
if (!isMore) {
if (this.findchar == undefined || this.findchar.length == 0) {
this.$vux.toast.text("请输入搜索关键字", "bottom");
return;
}

this.$vux.loading.show({
text: "请稍候..."
});

this.isShowOutLineLoadMore = true;
}

var minOutlineId = 0;
if (
isMore &&
this.outLineList != undefined &&
this.outLineList.length > 0
) {
minOutlineId = this.outLineList[this.outLineList.length - 1].ioutlineid;
}

this.$http({
method: "post",
url: "wxexam.ashx?op=SearchOutLineList",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
courseId: this.$store.getters.getClassInfo.CourseId,
findchar: this.findchar,
minOutlineId: minOutlineId,
pagesize: 20
}
})
.then(response => {
if (response.status == 200 && response.data.errcode == 0) {
if (this.outLineList != undefined && isMore) {
response.data.data.forEach(subject => {
this.outLineList.push(subject);
});
this.isOutLineLoadMore = false;
} else {
this.outLineList = response.data.data;
this.$vux.loading.hide();
}
} else {
this.isOutLineLoadMore = false;
this.$vux.loading.hide();
}

if (
response.data.data != undefined &&
response.data.data.length < 20
) {
this.isShowOutLineLoadMore = false;
}
})
.catch(function(error) {
console.log("error:" + error);
this.$vux.loading.hide();
this.isOutLineLoadMore = false;
});
},
onSubjectClick(subjectItem) {
var listId = Date.parse(new Date());
var stroageSubjectList = {
id: listId,
list: this.subjectList
};
sessionStorage.setItem("subjectList", JSON.stringify(stroageSubjectList));

this.$router.push({
path: "/SubjuectData",
query: {
subjectid: subjectItem.isubjectid,
showtime: this.GLOBAL.SubjectShowTime.Test,
listid: listId
}
});
},
onSubjectMore() {
this.isSubjectLoadMore = true;
this.searchSubjectList(true);
},
onOutLineMore() {
this.isOutLineLoadMore = true;
this.searchOutLineList(true);
}
},
computed: {
swiperHeight: function() {
return document.documentElement.clientHeight - 115 + "px";
}
},
watch: {
$route(to, from) {
if (from.path == "/") {
this.initData();
}
}
}
};



// WEBPACK FOOTER //
// ./src/components/SearchSubject.vue